import { render, staticRenderFns } from "./NovaVenda.vue?vue&type=template&id=198804a4&scoped=true"
import script from "./NovaVenda.vue?vue&type=script&lang=js"
export * from "./NovaVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198804a4",
  null
  
)

export default component.exports